import { Share2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { notify } from '@/lib/toast';
import { cn } from '@/lib/utils';

interface ShareLinkButtonProps {
  /** 사이트 안 경로(예: `/programs/12`) — 받는 사람이 로그인 없이 열 수 있는 공개 화면이어야 한다 */
  path: string;
  /** 공유 시트 제목 */
  title: string;
  className?: string;
}

/** 공유로 들어온 방문을 접근 로그에서 셀 수 있게 붙이는 표식 */
const SHARE_REF = 'ref=share';

/**
 * 링크 보내기 — 모바일은 시스템 공유 시트(카톡·문자), 공유 시트가 없으면 링크 복사. 받는 쪽은 공개 화면에서 가입 유도를 만난다.
 */
export function ShareLinkButton({ path, title, className }: ShareLinkButtonProps) {
  const url = `${window.location.origin}${path}${path.includes('?') ? '&' : '?'}${SHARE_REF}`;

  const onClick = async () => {
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, url });
        return;
      } catch (e) {
        // 사용자가 공유 시트를 닫음 — 알릴 것 없음
        if (e instanceof DOMException && e.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      notify.success('링크를 복사했어요', '보내고 싶은 곳에 붙여 넣으세요.');
    } catch {
      // 복사 권한이 없는 브라우저 — 주소를 보여 줘 직접 복사하게 한다(API 오류가 아니다)
      notify.info('아래 주소를 복사해 보내 주세요', url);
    }
  };

  return (
    <Button
      variant="ghost"
      className={cn('min-h-11 motion-safe:active:scale-[.98]', className)}
      onClick={() => void onClick()}
    >
      <Share2 aria-hidden />
      링크 보내기
    </Button>
  );
}
